import { Injectable } from '@angular/core';

import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

const TOKEN_HEADER_KEY = 'Authorization';



@Injectable({

  providedIn: 'root'

})

export class BasicAuthHtppInterceptorService implements HttpInterceptor {

  idtemp:string;
  temp:string;
  ID_TOKEN_HEADER_KEY = 'id_token';
  ID_ORG_Sandbox='org_id_demo';
  ID_ORG_PROD='org_id_prod';
  PATH='path';
  APITXNID='x-apitransactionid';
 demoOrgID:string;
 prodOrgID:string;
 path:string;

 aemReq;

  constructor() { 

   

  }




  intercept(req: HttpRequest<any>, next: HttpHandler) {

     if(localStorage.getItem("is_cuurent_nav_aem")){
        this.aemReq=localStorage.getItem("is_cuurent_nav_aem");
     }else{
      this.aemReq='n';
     }


  
     if(localStorage.getItem("devportal_id_token")){
      this.idtemp= localStorage.getItem("devportal_id_token");
      this.temp=localStorage.getItem("devportal_apic_token");
     }else{
      this.idtemp="dummy";
     }

    if(localStorage.getItem("org_id_demo")){
        this.demoOrgID=localStorage.getItem("org_id_demo");
        this.prodOrgID=localStorage.getItem("org_id_prod");
        this.path=localStorage.getItem("path");
    }else{

        this.demoOrgID="NA";
        this.prodOrgID="NA";
        this.path="NA";

    }


    if(localStorage.getItem("smart_app")){
      this.ID_TOKEN_HEADER_KEY="ID_Token";
    }



    let authReq = req;

   

   if(this.idtemp=="dummy" ||  this.aemReq=="y"){
   }
   else{
    let randomString = this.generateRandomString(10);
     authReq = req.clone({ headers: req.headers.
      set(this.ID_TOKEN_HEADER_KEY,this.idtemp).
      set(TOKEN_HEADER_KEY, 'Bearer ' +this.temp)
      .set(this.ID_ORG_Sandbox,this.demoOrgID)
      .set(this.ID_ORG_PROD, this.prodOrgID)
      .set(this.PATH, this.path) 
      .set(this.APITXNID, randomString)
      });   
   }
//    authReq = req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token).set("Content-Type","application/json") });

    return next.handle(authReq);

  }

  generateRandomString(length: number): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }


}
